'use client';

import { createContext } from 'react';
import type { CommandMenuSize } from './command-menu.types';

export const CommandMenuContext = createContext<{ size: CommandMenuSize }>({ size: 'sm' });
